import { cloneDeep } from "lodash";

export default {
  data() {
    return {
      hasTouch: false,
    }
  },
  created() {
    if(("ontouchstart" in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
      this.hasTouch = true;
    }
  },
  methods: {
    
    mergeArrayOfObjectsByKey: function(target, source, key="id", prefix="__", deep=false) {

      let result = {};

      target.filter(element => (typeof(element[key]) == "undefined")? false : true).forEach(element => {
        if(deep) {
          result[element[key]] = cloneDeep(element);
        }
        else {
          result[element[key]] = {};
          for(const prop in element) {
            result[element[key]][prop] = element[prop];
          }
        }
        result[element[key]].__t__ = true;
      });

      source.filter(element => (typeof(element[key]) == "undefined")? false : true).forEach(element => {
        if(typeof(result[element[key]]) != "undefined") {
          for(const prop in element) {
            if(prop != key) {
              if(deep) {
                result[element[key]][prefix + prop] = cloneDeep(element[prop]);
              }
              else {
                result[element[key]][prefix + prop] = element[prop];
              }
            }
          }
        }
        else {
          if(prefix == "") {
            if(deep) {
              result[element[key]] = cloneDeep(element);
            }
            else {
              result[element[key]] = {};
              for(const prop in element) {
                result[element[key]][prop] = element[prop];
              }
            }
          }
          else {
            result[element[key]] = {};
            for(const prop in element) {
              if(deep) {
                if(prop == key) {
                  result[element[key]][prop] = cloneDeep(element[prop]);
                }
                else {
                  result[element[key]][prefix + prop] = cloneDeep(element[prop]);
                }
              }
              else {
                if(prop == key) {
                  result[element[key]][prop] = element[prop];
                }
                else {
                  result[element[key]][prefix + prop] = element[prop];
                }
              }
            }
          }
        }
        result[element[key]].__s__ = true;
      });
      return result;
    },
    isLastCharNumber: function(str) {
      if(str.length == 0) return false;
      let code = str.charCodeAt(str.length-1);
      if(code < 48) return false;
      else if(code > 57) return false;
      else return true;
    },
    el: function(id) {
      return window.document.getElementById(id);
    },
    // this.objectMerge(toAdd, this.defaultDataset);
    objectMerge: function(state, value, propName, ignoreNull) {
      // eslint-disable-next-line
      if(Object.prototype.toString.call(value) === "[object Object]" && (propName == null || state.hasOwnProperty(propName))) {
        const o = (propName == null) ? state : state[propName];
        if(o != null) {
          for(let prop in value) {
            this.objectMerge(o, value[prop], prop, ignoreNull);
          }
          return;
        }
      }
      if(propName == null) {

      }
      else {
        if(!ignoreNull || value !== null) {
          this.$set(state, propName, value);
        }
      }
    },

// https://gist.github.com/oriadam/396a4beaaad465ca921618f2f2444d49

    colorValues: function(color) {
      if(!color) return;
      if(color.toLowerCase() === 'transparent') return [0, 0, 0, 0];

      if(color[0] === '#') {
        if(color.length < 7) {
          // convert #RGB and #RGBA to #RRGGBB and #RRGGBBAA
          color = '#' + color[1] + color[1] + color[2] + color[2] + color[3] + color[3] + (color.length > 4 ? color[4] + color[4] : '');
        }
        return [parseInt(color.substr(1, 2), 16),
          parseInt(color.substr(3, 2), 16),
          parseInt(color.substr(5, 2), 16),
          color.length > 7 ? this.roundValue(parseInt(color.substr(7, 2), 16)/255) : 1];
      }

      if(color.indexOf('rgb') === -1) {
        // convert named colors
        var temp_elem = document.body.appendChild(document.createElement('fictum')); // intentionally use unknown tag to lower chances of css rule override with !important
        var flag = 'rgb(1, 2, 3)'; // this flag tested on chrome 59, ff 53, ie9, ie10, ie11, edge 14
        temp_elem.style.color = flag;
        if(temp_elem.style.color !== flag) return; // color set failed - some monstrous css rule is probably taking over the color of our object
        temp_elem.style.color = color;
        if(temp_elem.style.color === flag || temp_elem.style.color === '')
        return; // color parse failed
        color = window.getComputedStyle(temp_elem).color;
        document.body.removeChild(temp_elem);
      }
      if(color.indexOf('rgb') === 0) {
        if(color.indexOf('rgba') === -1)
        color += ',1'; // convert 'rgb(R,G,B)' to 'rgb(R,G,B)A' which looks awful but will pass the regxep below
        return color.match(/[\d]+/g).map(function (a) {
          return +a
        });
      }
    },

    roundValue : function(num, decimals = 2) {
      let scaling = 10 ** decimals;
      return Math.round((num + Number.EPSILON) * scaling) / scaling;
    },

    reloadWindow: function() {
      window.location.reload(true);
    },
    showModal: function(modalId) {
      this.$bvModal.show(modalId);
    },
    hideModal: function(modalId) {
      this.$bvModal.hide(modalId);
    },
    selectText: function(node) {
      if(document.body.createTextRange) {
        const range = document.body.createTextRange();
        range.moveToElementText(node);
        range.select();
      }
      else if(window.getSelection) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(node);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    },
    goBack: function() {
      if(this.hasHistory()) {
        this.$router.go(-1);
      }
      else {
        this.$router.push('/');
      }
    },
    hasHistory: function() {
      return window.history.length > 2
    },
    getLang: function() {
      if(this.$cookies.isKey("lang")) {
        return JSON.parse(this.$cookies.get("lang"));
      }
      else {
        if(navigator.language.split("-")[0] == "ko") {
          return "ko";
        }
        else {
          return "en";
        }
      }
    },
    copyToClipboard: function(evt) {
      if(evt.srcElement) {
        this.$copyText(evt.srcElement.innerText);
      }
    },

    offsetTop: function(el) {
        return this.marginTop(el) + this.borderTopWidth(el) + this.paddingTop(el);
    },

    offsetBottom: function(el) {
        return this.marginBottom(el) + this.borderBottomWidth(el) + this.paddingBottom(el);
    },

    offsetLeft: function(el) {
        return this.marginLeft(el) + this.borderLeftWidth(el) + this.paddingLeft(el);
    },

    offsetRight: function(el) {
        return this.marginRight(el) + this.borderRightWidth(el) + this.paddingRight(el);
    },

    borderLeftWidth: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("border-left-width"));
    },

    paddingLeft: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("padding-left"));
    },

    marginLeft: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("margin-left"));
    },

    borderRightWidth: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("border-right-width"));
    },

    paddingRight: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("padding-right"));
    },

    marginRight: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("margin-right"));
    },

    borderTopWidth: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("border-top-width"));
    },

    paddingTop: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("padding-top"));
    },

    marginTop: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("margin-top"));
    },

    top: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("top"));
    },

    left: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("left"));
    },

    borderBottomWidth: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("border-bottom-width"));
    },

    paddingBottom: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("padding-bottom"));
    },

    marginBottom: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("margin-bottom"));
    },

    width: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("width"));
    },

    innerWidth: function(el) {
      return this.borderLeftWidth(el) + this.paddingLeft(el) + this.width(el) + this.paddingRight(el) + this.borderRightWidth(el);
    },

    outerWidth: function(el) {
      return this.marginLeft(el) + this.innerWidth(el) + this.marginRight(el);
    },

    height: function(el) {
      return parseFloat(window.getComputedStyle(el).getPropertyValue("height"));
    },

    innerHeight: function(el) {
      return this.borderTopWidth(el) + this.paddingTop(el) + this.height(el) + this.paddingBottom(el) + this.borderBottomWidth(el);
    },

    outerHeight: function(el) {
      return this.innerHeight(el) + this.marginTop(el) + this.marginBottom(el);
    },

    stopPropagation: function(evt) {
      evt.stopPropagation();
    },
    clone: function(o) {
      let output, v, key
      output = Array.isArray(o) ? [] : {}
      for (key in o) {
        v = o[key]
        if(v) output[key] = (typeof v === "object") ? this.clone(v) : v
        else output[key] = v
      }
      return output;
    },
    makeRandomNumber: function(min=-100, max=100) {
      return parseInt((Math.random() * (max-min)+min)*100)/100
    },
    getSecondsOfDay: function(date) {
      return date.getSeconds() + (60 * date.getMinutes()) + (60 * 60 * date.getHours())
    },
    sameDay: function(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()
    },
    isAM: function(date) {
      return (date.getHours() <12 && date.getHours() >= 0)? true: false
    },
    isPM: function(date) {
      return !this.isAM(date)
    },
    isDay: function(date) {
      return (date.getHours() <18 && date.getHours() >= 6)? true: false
    },
    isNight: function(date) {
      return !this.isDay(date)
    },
    makeRandomInt: function(min=-1000, max=1000) {
      return parseInt((Math.random() * (max - min + 1)) + min)
    },

    makeRandomString: function(min=2, max=8) {
      var charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+=_-,.&'"
      var str = ""
      var len = this.makeRandomInt(min,max)
      for(var i=0;i<len;i++) {
        var pos = Math.floor(Math.random() * charset.length)
        str += charset.substring(pos, pos+1)
      }
      return encodeURIComponent(str)
    },

    makeRandomValue: function(type, min, max, mode="loose") {
      var values = [
        ["false", 0, "0", "-1", -1],
        ["true", 1, "1", "+1", +1]
      ]
      if(type == "number" || type == "FLOAT_VAL") {
        return this.makeRandomNumber(min, max)
      }
      else if(type == "int" || type == "INT_VAL" || type == "UNSIGNED_INT_VAL" || type == "LONG_VAL" || type == "UNSIGNED_LONG_VAL") {
        return this.makeRandomInt(min,max)
      }
      else if(type == "boolean" || type == "BOOL_VAL") {
        if(mode == "loose") {
          var pos1 = this.makeRandomInt(0,1)
          var pos2 = this.makeRandomInt(0,2)
          return values[pos1][pos2]
        }
        else {
          var val = this.makeRandomInt(0,1)
          return (val==0)? false: true
        }
      }
      else if(type == "string") {
        return this.makeRandomString(4,8)
      }
      else {
        return null
      }
    },
    disableContextMenu: function(evt) {
      evt.returnValue = false
    },
    disableCtrlV: function(evt) {
      var keystroke = String.fromCharCode(evt.keyCode).toLowerCase()
      if(evt.ctrlKey && keystroke == 'v') {
        evt.returnValue = false
      }
    },
    undefinedOrNull: function(item) {
      if(typeof(item) == "undefined") return true
      else if(item === null) return true
      else return false
    },
    definedAndTrue: function(item) {
      if(typeof(item) == "undefined") return false
      if(item === true) return true
      return false
    },
    countAttributes: function(obj) {
      let count = 0;
      // eslint-disable-next-line
      for(let prop in obj) count++;
      return count;
    },
    countTrueAttibutes: function(obj) {
      let count = 0
      for(var prop in obj) {
        if(obj[prop] === true) {
          count++
        }
      }
      return count
    },
    countFalseAttibutes: function(obj) {
      let count = 0
      for(var prop in obj) {
        if(obj[prop] === false) {
          count++
        }
      }
      return count
    },
    newLineToBr: function(str) {
      return str.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/\r?\n/g, "<br/>")
    },
    aWeekLater: function(date=(new Date())) {
      return new Date(date.getTime() + 7 * 24 * 60 * 60 * 1000)
    },
    aDayLater: function(date=(new Date())) {
      return new Date(date.getTime() + 1 * 24 * 60 * 60 * 1000)
    },

    toISOString: function(date) {
      var tzo = -date.getTimezoneOffset(),
      dif = tzo >= 0 ? '+' : '-',
      pad = function(num) {
        var norm = Math.floor(Math.abs(num))
        return (norm < 10 ? '0' : '') + norm
      }
      return date.getFullYear() +
      '-' + pad(date.getMonth() + 1) +
      '-' + pad(date.getDate()) +
      'T' + pad(date.getHours()) +
      ':' + pad(date.getMinutes()) +
      ':' + pad(date.getSeconds()) +
      dif + pad(tzo / 60) +
      ':' + pad(tzo % 60)
    },

    toISOStringWithoutZone: function(date) {
      var pad = function(num) {
        var norm = Math.floor(Math.abs(num))
        return (norm < 10 ? '0' : '') + norm
      }
      return date.getFullYear() +
      '-' + pad(date.getMonth() + 1) +
      '-' + pad(date.getDate()) +
      'T' + pad(date.getHours()) +
      ':' + pad(date.getMinutes()) +
      ':' + pad(date.getSeconds())
    },

    stringToDate: function(datestr) {
      let splitted = datestr.trim().split(" ");
      if(splitted.length == 2) {
        let dateArray = splitted[0].trim().split(".");
        let timeArray = splitted[1].trim().split(":");
        if(dateArray.length == 3 && timeArray.length) {
          return new Date(parseInt(dateArray[0],10), parseInt(dateArray[1],10)-1, parseInt(dateArray[2],10), parseInt(timeArray[0],10), parseInt(timeArray[1],10), parseInt(timeArray[2],10));
        }
      }
    },

    dateToTillHourString: function(date, sep1=".", sep2=" ") {
      var _result = ''
      if(date === null) return _result
      _result += date.getFullYear()
      _result += sep1
      _result += date.getMonth() < 9 ? '0' + (date.getMonth()+1) : date.getMonth()+1
      _result += sep1
      _result += date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      _result += sep2
      _result += date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      return _result;
    },

    dateToString: function(date, sep1=".", sep2=" ", sep3=":") {
      var _result = ''
      if(date === null) return _result
      _result += date.getFullYear()
      _result += sep1
      _result += date.getMonth() < 9 ? '0' + (date.getMonth()+1) : date.getMonth()+1
      _result += sep1
      _result += date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      _result += sep2
      _result += date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      _result += sep3
      _result += date.getMinutes() < 10 ? '0' + date.getMinutes(): date.getMinutes()
      _result += sep3
      _result += date.getSeconds() < 10 ? '0' + date.getSeconds(): date.getSeconds()
      return _result;
    },

    dateToTillMonthString: function(date, sep=".") {
      var _result = ''
      if(date === null) return _result
      _result += date.getFullYear()
      _result += sep
      _result += date.getMonth() < 9 ? '0' + (date.getMonth()+1) : date.getMonth()+1
      return _result;
    },

    dateToDateOnlyString: function(date, sep=".") {
      var _result = ''
      if(date === null) return _result
      _result += date.getFullYear()
      _result += sep
      _result += date.getMonth() < 9 ? '0' + (date.getMonth()+1) : date.getMonth()+1
      _result += sep
      _result += date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return _result;
    },

    toDMSString: function(coordinate) {
      if(coordinate === null) return "";
      let absolute = Math.abs(coordinate);
      let degrees = Math.floor(absolute);
      let minutesNotTruncated = (absolute - degrees) * 60;
      let minutes = Math.floor(minutesNotTruncated);
      let seconds = Math.floor((minutesNotTruncated - minutes) * 60);
      return degrees + '\u00B0' + minutes + '\u0027' + seconds + '\u0022';
    },

    geopointToGmapLatLng: function(gp) {
      this.$log.debug(gp);
      if(typeof(gp) == "undefined") return null;
      if(gp == null) return null;
      let _obj = this.geopointToJsLatLng(gp);
      if(_obj == null) return null;
      // eslint-disable-next-line
      return new google.maps.LatLng(_obj.lat, _obj.lng);
    },

    computeDistanceBetween: function(gp1, gp2) {
      this.$log.debug(gp1, gp2);
      // eslint-disable-next-line
      return google.maps.geometry.spherical.computeDistanceBetween(gp1, gp2);
    },

    geopointIsInsideViewPort: function(gp, vp) {
      this.$log.debug(gp, vp);
      if(typeof(gp) == "undefined") return false;
      if(gp == null) return false;
      if(typeof(vp) == "undefined") return false;
      if(vp == null) return false;
      let _gp, _vpTopLeft, _vpBottomRight;
      if(Array.isArray(vp)) {
        _gp = this.geopointToJsLatLng(gp);
        _vpTopLeft = vp[0];
        _vpBottomRight = vp[1];
      }
      else {
        _gp = this.geopointToJsLatLng(gp);
        _vpTopLeft = this.viewPortTopLeft(vp);
        _vpBottomRight = this.viewPortBottomRight(vp);
      }
      if(_gp == null) return false;
      if(_vpTopLeft == null) return false;
      if(_vpBottomRight == null) return false;

      // - 90 ~ 90
      if(_gp.lat > _vpTopLeft.lat) return false;
      if(_gp.lat < _vpBottomRight.lat) return false;

      if(_vpTopLeft.lng > _vpBottomRight.lng) {
        if(_gp.lng < _vpTopLeft.lng) return false;
        if((_gp.lng < 0) && (_gp.lng > _vpBottomRight.lng)) return false;
      }
      // - 180 ~ 180
      else {
        if(_gp.lng < _vpTopLeft.lng) return false;
        if(_gp.lng > _vpBottomRight.lng) return false;
      }
      return true;
    },

    geopointToJsLatLng: function(gp) {
      if(typeof(gp) == "undefined") return null;
      if(gp == null) return null;
      let _obj = {};

      if(typeof(gp._lat) !="undefined") _obj.lat = gp._lat;
      else if(typeof(gp.lat) == "function") _obj.lat = gp.lat();
      else if(typeof(gp.lat) != "undefined") _obj.lat = gp.lat;
      else if(typeof(gp.latitude) != "undefined") _obj.lat = gp.latitude;

      if(typeof(gp._lng) !="undefined") _obj.lng = gp._lng;
      else if(typeof(gp.lng) == "function") _obj.lng = gp.lng();
      else if(typeof(gp.lng) != "undefined") _obj.lng = gp.lng;
      else if(typeof(gp.longitude) != "undefined") _obj.lng = gp.longitude;

      if(typeof(_obj.lat) == "undefined" || typeof(_obj.lng) == "undefined") {
        return null;
      }
      else {
        return _obj;
      }
    },

    viewPortTopLeft: function(vp) {
      if(vp == null) return null;
      let _obj = {};

      // latitude 위도 37
      // longitude 경도 126

      // this.$log.debug(vp.Ya.i); // 37.5146857197085 bottom // lat
      // this.$log.debug(vp.Sa.j); // 126.8354280802915 right // lng

      // this.$log.debug(vp.Ya.j); // 37.51738368029149 top // lat
      // this.$log.debug(vp.Sa.i); // 126.8327301197085 left // lng

      // La.g(126.832), La.i(126.835), Ua.g(37.514), Ua.i(37.517)


      if(typeof(vp.Sa) != "undefined" && typeof(vp.Sa.i) != "undefined") {
        _obj.lng = vp.Sa.i;
      }
      else if(typeof(vp.La) != "undefined" && typeof(vp.La.g) != "undefined") {
        _obj.lng = vp.La.g;
      }
      else if(typeof(vp.Eb) != "undefined" && typeof(vp.Eb.i) != "undefined") {
        _obj.lng = vp.Eb.i;
      }

      if(typeof(vp.Ya) != "undefined" && typeof(vp.Ya.j) != "undefined") {
        _obj.lat = vp.Ya.j;
      }
      else if(typeof(vp.Ua) != "undefined" && typeof(vp.Ua.i) != "undefined") {
        _obj.lat = vp.Ua.i;
      }
      else if(typeof(vp.oc) != "undefined" && typeof(vp.oc.g) != "undefined") {
        _obj.lat = vp.oc.g;
      }

      if(typeof(_obj.lng) == "undefined" || typeof(_obj.lat) == "undefined") {
        return null;
      }
      return _obj;
    },

    viewPortBottomRight: function(vp) {
      if(vp == null) return null;

      let _obj = {};

      // Eb.g 126.8327301197085
      // Eb.i 126.8354280802915
      // oc.g 37.5146857197085
      // oc.i 37.51738368029149

      // latitude 위도 37
      // longitude 경도 126
      // (vp.Ya.j, vp.Sa.i) ........... (vp.Ya.j, vp.Sa.j)
      // (vp.Ua.i, vp.La.g)
      // (vp.oc.g, vp.Eb.i)
      //
      //                                (vp.oc.i, vp.Eb.g)
      //                                (vp.Ua.g, vp.La.i)
      // (vp.Ya.i, vp.Sa.i) ........... (vp.Ya.i, vp.Sa.j)

      // this.$log.debug(vp.Ya.i); // 37.5146857197085 bottom // lat
      // this.$log.debug(vp.Sa.j); // 126.8354280802915 right // lng

      // this.$log.debug(vp.Ya.j); // 37.51738368029149 top // lat
      // this.$log.debug(vp.Sa.i); // 126.8327301197085 left // lng

      // La.g(126.832), La.i(126.835), Ua.g(37.514), Ua.i(37.517)

      if(typeof(vp.Ya) != "undefined" && typeof(vp.Ya.i) != "undefined") {
        _obj.lat = vp.Ya.i;
      }
      else if(typeof(vp.Ua) != "undefined" && typeof(vp.Ua.g) != "undefined") {
        _obj.lat = vp.Ua.g;
      }
      else if(typeof(vp.oc) != "undefined" && typeof(vp.oc.i) != "undefined") {
        _obj.lat = vp.oc.i;
      }

      if(typeof(vp.Sa) != "undefined" && typeof(vp.Sa.j) != "undefined") {
        _obj.lng = vp.Sa.j;
      }
      else if(typeof(vp.La) != "undefined" && typeof(vp.La.i) != "undefined") {
        _obj.lng = vp.La.i;
      }
      else if(typeof(vp.Eb) != "undefined" && typeof(vp.Eb.g) != "undefined") {
        _obj.lng = vp.Eb.g;
      }

      if(typeof(_obj.lng) == "undefined" || typeof(_obj.lat) == "undefined") {
        return null;
      }
      else return _obj;
    },

    geopointToLatLngString : function(gp) {
      if(!gp) return "";
      let _obj = this.geopointToJsLatLng(gp);
      if(_obj == null) return "";
      return JSON.stringify(_obj);
    },

    scrollToBottom: function(el) {
      window.setTimeout(() => {
        if(typeof(el) != "undefined") {
          el.scroll({
            top: (el.scrollHeight),
            left: 0,
            behavior: 'smooth'
          });
        }
      }, 100);
    },

    geopointToDMSString: function(gp) {
      if(!gp) return "";
      let _obj = this.geopointToJsLatLng(gp);
      if(_obj==null) return "";
      let _result = "";
      if(_obj.lat >= 0) _result += "N";
      else _result += "S";
      _result += this.toDMSString(_obj.lat);
      if(_obj.lng >= 0) _result += " E";
      else _result += " W";
      _result += this.toDMSString(_obj.lng);
      return _result;
    },

    makeToast: function(variant = null, title="", body="", options={}) {
      this.toastCount++
      this.$bvToast.toast(body, Object.assign({
        solid: true,
        autoHideDelay: 3000,
        appendToast: true,
        title: title,
        variant: variant,
        size: "lg"
      }, options)) // no-auto-hide: true
    },
    modalShowFocus: function(evt) {
      if(typeof(evt.vueTarget.$el.dataset.nextfocus) != "undefined") {
        var list = evt.vueTarget.$el.dataset.nextfocus.split(",")
        var target = null
        for(var i=0;i<list.length;i++) {
          if(window.document.getElementById(list[i].trim()) != null) {
            target = window.document.getElementById(list[i].trim())
            break
          }
        }
        if(target != null) {
          window.setTimeout(() => {
            target.focus()
          },300)
        }
      }
      return false
    },
    enterKeyChecker: function(evt) {
      if(evt.keyCode === 13) {
        if(evt.srcElement.reportValidity()) {
          if(typeof(evt.srcElement.dataset.nextfocus) != "undefined") {
            var list = evt.srcElement.dataset.nextfocus.split(",")
            var target = null
            for(var i=0;i<list.length;i++) {
              if(window.document.getElementById(list[i].trim()) != null) {
                target = window.document.getElementById(list[i].trim())
                break
              }
            }
            if(target != null) {
              window.document.getElementById(evt.srcElement.dataset.nextfocus).focus()
            }
          }
        }
      }
      return false
    },
    tinkTypeof: function(value) {
      if(typeof(value) == "object") {
        if(value instanceof Boolean) return "boolean";
        else if(value instanceof Number) return "number";
        else if(value instanceof String) return "string";
        else if(value instanceof Date) return "date";
        else if(value instanceof Function) return "function";
        else if(value instanceof Array) return "array";
        else {
          return "object";
        }
      }
      else {
        return typeof(value);
      }
    },
    testUserAgent: function(str) {
      let re = new RegExp(str, 'i');
      return re.test(navigator.userAgent);
    },
    isAndroid: function() {
        return this.testUserAgent("Android");
    },
    isIOS: function() {
        return this.testUserAgent("iPhone|iPad|iPod");
    },
    isChrome: function() {
        return this.testUserAgent("Chrome");
    },
    isMSIE: function() {
        return this.testUserAgent("MSIE");
    },
    isEdge: function() {
        return this.testUserAgent("Edge");
    },
    isOpera: function() {
        return this.testUserAgent("Opera|OPR");
    },
    isSafari: function() {
        return this.testUserAgent("Safari");
    },
    isFirefox: function() {
        return this.testUserAgent("Firefox");
    },
  },
}
